import React from 'react';
import PropTypes from 'prop-types';
import Image from '../image';

import styles from './index.module.scss';

const IconBox = ({ data, className, ...other }) => {
	if (!data) return null;

	return (
		<div
			className={`${styles.iconBox} ${className || ''}`}
			{...other}
		>
			{data.image?.[0] && (
				<Image
					data={data.image[0]}
					className={styles.iconBox_Image}
					objectFit='contain'
				/>
			)}
			{data.heading && (
				<div
					className={styles.iconBox_Heading}
					dangerouslySetInnerHTML={{ __html: data.heading }}
				/>
			)}
		</div>
	);
};

IconBox.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default IconBox;
